/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogResults } from '../models/LogResults';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LogEventService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all log events in the DB.
     * @param logLevel Optional filter for log level (e.g., "Information", "Error").
     * @param pageNumber The page number for pagination (1-based).
     * @param pageSize The number of log events to return per page (default is 50).
     * @returns LogResults OK
     * @throws ApiError
     */
    public getAllLogEvents(
        logLevel?: string,
        pageNumber?: number,
        pageSize: number = 50,
    ): CancelablePromise<LogResults> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/logging/LogEvent/GetAllLogEvents',
            query: {
                'logLevel': logLevel,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
